<template>
  <div v-if="visivel" class="w3-modal" style="display: block;">
    <div class="w3-container w3-modal-content w3-animate-zoom">

      <header>
        <span
          @click="fechar()"
          class="w3-button w3-display-topright">&times;</span>

        <h4 class="texto-vermelho titulo">Pesquisar Cliente</h4>
      </header>

      <div class="w3-col" v-if="mostrar_filtros">

        <div style="padding: 0">

          <div
            class="w3-col s2 m1 w3-dropdown-hover w3-transparent w3-center"
            style="margin-top: 22px;">

            <button class="w3-button w3-border texto-vermelho">
              <i class="fa fa-cog"></i>
            </button>

            <div
              class="w3-dropdown-content w3-bar-block w3-border"
              style="width: 0px;">

              <div
                :key="tipo_pesquisa.indice_tela"
                v-for="tipo_pesquisa in tipos_pesquisa">

                <button 
                  class="w3-bar-item w3-button botao-quadrado" 
                  @click="setChavePesquisa(tipo_pesquisa.indice_tela)">
                  
                  <i :class="getIconeFiltro(tipo_pesquisa.indice_tela)"></i>
                  <span>{{tipo_pesquisa.descricao_pesquisa}}</span>
                </button>

              </div>
            </div>
          </div>

          <div class="w3-col s10 m8 l9" style="padding-left:10px;">
            <label for="campoPesquisa">
              <span>{{tipos_pesquisa[indice_selecionado].descricao_pesquisa}}</span>
            </label>
                
            <input 
              ref="campoPesquisa"
              autocomplete="off"
              id="campoPesquisa"
              v-model="chave_pesquisa"
              class="w3-input w3-border w3-block"
              :style="getStyleChavePesquisa()" 
              :placeholder="tipos_pesquisa[indice_selecionado].placeholder"
              :type="tipos_pesquisa[indice_selecionado].type"
              v-on:keyup="converterMaiusculo()"
              v-on:keyup.enter="buscar(false)">
          </div>

          <div class="w3-col m3 l2 w3-padding-small" style="padding:0px 0"> 
            <button 
              class="w3-col w3-button w3-theme w3-right" 
              style="margin-top: 20px;"
              v-on:click="buscar(false)"
              :disabled="processando">
              <span>Pesquisar</span>
            </button>                  
          </div>
        </div>
      </div>

      <div
        v-if="
        (
          (dados_filtrados.length > 0) &&
          (!processando) &&
          (mostrar_filtros)
        )"
        class="w3-col w3-center"
        style="margin-top: 1px;">
        
        <i
          class="fas fa-caret-down"
          @click="mostrar_filtros = false"
          style="font-size: 24px; cursor: pointer;">
        </i>
      </div>

      <div class="w3-col w3-left">
        <button 
          class="w3-bar-item w3-button w3-col w3-white w3-border w3-mobile" 
          v-if="!mostrar_filtros" v-on:click="mostrar_filtros = !mostrar_filtros">
          <i class="fa fa-filter icone-vermelho"></i>
          <span> Mostrar filtros</span>
        </button>
      </div>

      <div v-if="!mostrar_filtros">
        <div class="w3-col s12 w3-margin-top w3-margin-bottom">            
          <div
            v-show="dados_filtrados.length > 0" 
            class="w3-responsive w3-small"
            v-if="!mostrar_filtros" 
            style="max-height: calc(75vh - 300px); min-height: 200px; overflow: auto" >

            <div
              class=""
              :key="cliente.cadastro_id"
              v-for="cliente in dados_filtrados"
              @click="confirmar(cliente)">

              <div class="w3-col card-itens w3-border w3-padding-small" style='cursor: pointer; white-space: normal; font-size:14px;'>
                <strong>{{nPadrao(cliente.cadastro_id, 0)}} - <strong class="w3-text-theme">{{cliente.nome_razao_social}}</strong>&nbsp;-&nbsp;</strong>
                <span v-if="cliente.cnpj">{{cliente.cnpj}}</span>
                <span v-if="cliente.cpf">{{cliente.cpf}}</span>
              </div>
            </div>

          </div>
          <div class="w3-col l12 w3-right w3-margin-top" v-if="mostrar_botao_ver_mais">
            <button 
              :disabled="processando_ver_mais"
              v-on:click="adicionarClienteVerificandoDados(true)"
              class="w3-button w3-theme w3-right">
              <span>Ver mais</span>
            </button>
          </div>
        </div>

        <footer class="w3-container conteudo-centralizado"></footer>
      </div>
    </div>
  </div>
</template>

<script>
  import Biblioteca from '@/components/Repositorio/Biblioteca';
  import RCliente from '@/components/Rest/RCliente/RCliente.js'

  export default {
    name: 'PesquisaClientes',

    data() {
      return {
        visivel: false,
        chave_pesquisa: '',
        indice_selecionado: 1,
        apenas_cliente_simplificado: 'N',
        mostrar_botao_ver_mais: false,
        processando_ver_mais: false,

        tipos_pesquisa: [
          {
            indice_tela: 0,
            tipo: 'COD',
            descricao_pesquisa: 'Código',
            placeholder: 'Digite o código',
            type: "number"
          },

          {
            indice_tela: 1,
            tipo: 'NOM',
            descricao_pesquisa: 'Nome',
            placeholder: 'Digite o nome',
            type: "text"
          },

          {
            indice_tela: 2,
            tipo: 'CPJ',
            descricao_pesquisa: 'CPF/CNPJ',
            placeholder: 'Digite o CPF/CNPJ',
            type: "number"
          },
          {
            indice_tela: 3,
            tipo: 'EMA',
            descricao_pesquisa: 'E-mail',
            placeholder: 'Digite o e-mail',
            type: "text"
          },
          {
            indice_tela: 4,
            tipo: 'TEL',
            descricao_pesquisa: 'Telefone',
            placeholder: 'Digite o telefone',
            type: "number"
          },
          {
            indice_tela: 5,
            tipo: 'IES',
            descricao_pesquisa: 'Inscrição estadual',
            placeholder: 'Digite o inscrição estadual',
            type: "number"
          }
        ],

        processando: false,
        mostrar_filtros: true,
        dados_filtrados: [],
        clientes_ja_mostrados_ids: [],
      
      }
    },

    methods: {
      abrir(apenas_cliente_simplificado) {
        this.iniciarComponente();

        if (!Biblioteca.em(apenas_cliente_simplificado, ['N', 'S'])) {
          Biblioteca.exclamar('Defina se a consulta será apenas de clientes simplificados!');
        }

        this.apenas_cliente_simplificado = apenas_cliente_simplificado;
        
        this.$nextTick(() => this.$refs.campoPesquisa.focus());
      },

      iniciarComponente(){
        this.visivel = true;
        this.chave_pesquisa = '';
        this.indice_selecionado = 1;
        this.mostrar_filtros = true;
        this.dados_filtrados = [];
        this.clientes_ja_mostrados_ids = [];
      },

      confirmar(cliente) {
        if (this.apenas_cliente_simplificado == 'S') {
          if (cliente.e_cliente_simplificado != 'S') {
            Biblioteca.exclamar(
              'O cliente ' + Biblioteca.nPadrao(cliente.cadastro_id, 0) + ' - ' +
              cliente.nome_fantasia + ' ' + 
              'não é um cliente simplificado!'
            );
            return;
          }
        }

        this.$emit('confirmar', cliente);
        this.visivel = false;
      },

      fechar() {
        this.visivel = false;
      },

      setChavePesquisa(indice) {
        if (indice != this.indice_selecionado) {
          this.chave_pesquisa = '';
        }

        this.indice_selecionado = indice;
        this.$nextTick(() => this.$refs.campoPesquisa.focus());
      },

      getIconeFiltro(indice) {
        if(indice == this.indice_selecionado) {
          return 'fa fa-check-square icone-vermelho';
        }

        return 'far fa-square';
      },

      getStyleChavePesquisa() {
        if(this.tipos_pesquisa[this.indice_selecionado].tipo == 'EMA') {
          return 'border-radius:4px; text-transform:lowercase';
        }

        return "border-radius:4px; text-transform:uppercase";
      },

      converterMaiusculo() {
        let tipo_selecionado = this.tipos_pesquisa[this.indice_selecionado].tipo;

        if (tipo_selecionado == 'EMA') {
          this.chave_pesquisa = this.chave_pesquisa.toLowerCase();
        }
        else {
          this.chave_pesquisa = this.chave_pesquisa.toUpperCase();
        }
      },

      verificarDados() {
        let tipo_selecionado = this.tipos_pesquisa[this.indice_selecionado].tipo;

        if (
          (tipo_selecionado == 'COD') &&
          (
            (parseInt(this.chave_pesquisa) < 0) ||
            (parseInt(this.chave_pesquisa) > 9999999999)
          )
        ) {
          Biblioteca.exclamar('Digite um código válido!');
          return false;
        }

        if (
          (tipo_selecionado == 'NOM') &&
          (this.chave_pesquisa.length < 3)
        ) {
          Biblioteca.exclamar('É necessário digitar no mínimo 3 caracteres de pesquisa!');
          return false;
        }

        if (
          (tipo_selecionado == 'CPJ') &&
          (!Biblioteca.em(Biblioteca.numeros(this.chave_pesquisa).length, [11, 14]))
        ) {
          Biblioteca.exclamar('Inform um CPF/CPNJ sem números!');
          return false;
        }

        if (
          (tipo_selecionado == 'EMA') &&
          (!Biblioteca.validarEMail(this.chave_pesquisa))
        ) {
          Biblioteca.exclamar('Informe um e-mail válido!');
          return false;
        }

        if (
          (tipo_selecionado == 'TEL') &&
          (Biblioteca.numeros(this.chave_pesquisa).length < 5)
        ) {
          Biblioteca.exclamar('Informe um telefone válido!');
          return false;
        }

        if (
          (tipo_selecionado == 'IES') &&
          (Biblioteca.numeros(this.chave_pesquisa).length < 5)
        ) {
          Biblioteca.exclamar('Informe uma inscrição estadual válida!');
          return false;
        }

        return true;
      },

      async buscar(ver_mais) {
        try {
          if (!this.verificarDados()) {
            return;
          }

          let tipo_selecionado = this.tipos_pesquisa[this.indice_selecionado].tipo;

          this.processando = true;
          this.dados_filtrados = [];

          let parametros = {
            tipo: tipo_selecionado,
            chave: this.chave_pesquisa,
            clientes_ja_mostrados_ids: this.clientes_ja_mostrados_ids,
            apenas_clientes_ativos: 'N'
          };

          let retorno = await RCliente.pesquisarClientes(this.axios, parametros);
        
          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }

          this.dados_filtrados =  retorno.dados.clientes;

          this.mostrar_filtros = false;
          this.processando = false;
          this.mostrar_botao_ver_mais = retorno.dados.tem_continuacao == 'S';
          
          
          if(ver_mais){
  
            for (let i in this.dados_filtrados) {
              this.clientes_ja_mostrados_ids.push(this.dados_filtrados[i].cadastro_id);
            }
            
          }
          else{
            this.clientes_ja_mostrados_ids = [];
          }
        
        }
        catch (e) {
          this.processando = false;
          Biblioteca.exclamar(e.message);
        }
      },
      
      adicionarClienteVerificandoDados(ver_mais) {
        for (let i in this.dados_filtrados) {
          this.clientes_ja_mostrados_ids.push(this.dados_filtrados[i].cadastro_id);
        }
        this.pesquisar(ver_mais);
      },
      
      buscarClasseCampoPesquisa() {
        let retorno = 'w3-input w3-border';

        if (!Biblioteca.stringVazia(this.chave_pesquisa)) {
          let tipo_selecionado = this.tipos_pesquisa[this.indice_selecionado].tipo;
          if (tipo_selecionado == 'EMA') {
            retorno = retorno + ' tudo-minusculo';
          }
          else {
            retorno = retorno + ' tudo-maiusculo';
          }
        }

        return retorno;
      },

      nPadrao(valor, casas_decimais){
        return Biblioteca.nPadrao(valor, casas_decimais);
      }
    }
  }
</script>

<style escoped>
  .card-itens{
    border-radius: 10px 10px 10px 10px;
    box-shadow: #f3f3f3 1px 3px 5px 3px ;
    border-bottom: 0px dotted #666666;
    margin-top: 5px;
  }
  
  @media screen and (min-width: 1200px) {
    .w3-modal-content {
      width: 80%;
    }
  }

  @media screen and (max-width: 1199px) {
    .w3-modal-content {
      width: 95%;
    }
  }

  .fundo-enfase {
    background-color: #dedede;
  }

  .tudo-minusculo {
    text-transform: lowercase;
  }

  .tudo-maiusculo {
    text-transform: uppercase;
  }

</style>


// WEBPACK FOOTER //
// src/components/Pesquisas/PesquisaClientes.vue